import axios from 'axios';
import qs from 'qs';


const removeEmpty = (obj) => {
    Object.keys(obj).forEach((k) => (!obj[k] && obj[k] !== undefined) && delete obj[k]);
    return obj;
};

let DOMAIN = '';
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    if (process.env.REACT_APP_API_DOMAIN) {
        DOMAIN = process.env.REACT_APP_API_DOMAIN;
    }
} else {
    // production code
    // DOMAIN = 'https://lwd.api.adidodev.com';
    // DOMAIN = 'http://publicapi.livewelldorset.co.uk.mark';
    DOMAIN = 'https://publicapi.livewelldorset.co.uk';
    // DOMAIN = 'https://publicapi.directory.adidodev.com';
}

const api = {
    sendGet(endpoint, cb) {
        axios
            .get(endpoint)
            .then(response =>
                // If request is good...
                cb(null, response))
            .catch(error => api.handleError(error, cb));
    },

    handleError(error, cb) {
        console.error(error);
    },

    getFilters(params, cb) {
        api.sendGet(`${DOMAIN}/directory/filter/list?${qs.stringify(removeEmpty(params), { encode: false })}`, cb);
    },
    // address=bh1 1jn&radius=100&filters[3][0]=1&filters[3][1]=2&filters[4][0]=6&filters[4][1]=7
    searchActivities(params, cb) {
        api.sendGet(`${DOMAIN}/directory/search?${qs.stringify(removeEmpty(params), { encode: false })}`, cb);
    },

};
export default api;

export const apiLoginError = msg => ({
    type: 'API_LOGIN_ERROR',
    msg,
});
